import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { Container, Alert, Button } from 'react-bootstrap';

const RoleBasedRoute = ({ allowedRoles }) => {
	const { currentUser, userRole, logout } = useAuth();
	const location = useLocation();

	if (!currentUser) {
		// Not logged in, redirect to portal login
		return (
			<Navigate to='/portal/login' replace state={{ from: location }} />
		);
	}

	if (!userRole) {
		// Signed in but no users doc (§3g flip: accounts are enrollment-gated,
		// created only by the claim flow — never on bare sign-in). AuthProvider
		// resolves the profile before rendering children, so a null role here
		// is a real unlinked sign-in, not a loading state.
		return (
			<Container className='mt-5' style={{ maxWidth: '540px' }}>
				<Alert variant='info'>
					<Alert.Heading>Almost there!</Alert.Heading>
					<p>
						This sign-in isn't linked to a portal account yet.
						Portal accounts are set up through an emailed invite
						after your family is placed for lessons — check your
						inbox for a "Set up your account" email from us, or
						reach out and we'll send you a fresh link.
					</p>
					<div className='d-grid'>
						<Button
							variant='outline-secondary'
							onClick={() => logout()}>
							Sign out
						</Button>
					</div>
				</Alert>
			</Container>
		);
	}

	if (!allowedRoles.includes(userRole)) {
		// User doesn't have permission
		return (
			<Container className='mt-5'>
				<Alert variant='danger'>
					<Alert.Heading>Access Denied</Alert.Heading>
					<p>
						You don't have permission to access this page. Please
						contact support if you believe this is an error.
					</p>
				</Alert>
			</Container>
		);
	}

	// User has the correct role
	return <Outlet />;
};

export default RoleBasedRoute;
